import React from "react";
import { connect } from "react-redux";
import { PDPAParticipationDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import momentTZ from "moment-timezone";
import moment from "moment";
import * as XLSX from "xlsx";
import queryString from "query-string";
import { Inputs, Displays, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class PDPAParticipationDetailContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_PDPA_HISTORY_LIST_BY_PDPA_ID(
      this.props.router.params.id,
      stringQuery
    );
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handleClickDetail = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.CUSTOMER}/${e.customer_ref_id}`);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(
      `${ROUTE_PATH.PDPA}/participation/${this.props.router.params.id}${joinQuery}`
    );
    this.fetchData(joinQuery);
  };

  handleExport = async (permission) => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;
    let res = await portalService.GET_PDPA_HISTORY_LIST_BY_PDPA_ID(
      this.props.router.params.id,
      joinQuery
    );
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "SheetJS";
      /* make worksheet */
      let ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          i + 1,
          momentTZ(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY"),
          `${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: e.first_name,
            action: "export",
          })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: e.last_name,
            action: "export",
          })}`,
          RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: e.phone_number,
            type: "phone",
            action: "export",
          }),
          e.email,
          e.pdpa_code,
          e.is_accepted_privacy_pdpa ? 1 : 0,
          e.is_accepted_product_warranty_pdpa ? 1 : 0,
          e.is_accepted_certified_true_info_pdpa ? 1 : 0,
          e.is_accepted_marketing_pdpa ? 1 : 0,
        ]);
        return result;
      }, []);
      ws_data.splice(0, 0, [
        "No",
        "Create Date",
        "Name",
        "Phone",
        "Email",
        "PDPA code",
        "Privacy",
        "Warranty",
        "Certified true info",
        "Marketing",
      ]);
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      let wscols = [
        { wch: 5 },
        { wch: 15 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
      ];
      ws["!cols"] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `pdpa-report-${moment().tz("Asia/Bangkok").format("DD/MM/YYYY")}.xlsx`
      );
      this.setState({
        isBgLoading: false,
      });
    }
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, isBgLoading, pagination, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "pdpa");
    return (
      <PDPAParticipationDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search)}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
          onExport={
            permission &&
            (permission.is_export || permission.is_export_condition)
              ? () => this.handleExport(permission)
              : false
          }
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table">
              <Tables.Standard
                columns={columns({
                  papaType: data?.pdpa_type ? data.pdpa_type : "1",
                  handleClickDetail: this.handleClickDetail,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
      </PDPAParticipationDetailContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "first_name",
      length: "311px",
      filter: {
        fieldQuery: "first_name",
        defaultValue: initialValues["first_name"],
        type: "text",
        label: "Name",
        placeholder: "Name",
      },
    },
    {
      accessor: "pdpa_type",
      length: "311px",
      filter: {
        fieldQuery: "pdpa_type",
        defaultValue: initialValues["pdpa_type"],
        type: "dropdown",
        label: "Type",
        placeholder: "",
        options: [
          {
            label: "All",
            value: "",
          },
          {
            label: "General Privacy",
            value: "1",
          },
          {
            label: "Warranty",
            value: "2",
          },
          {
            label: "Cetified true info",
            value: "3",
          },
          {
            label: "Marketing",
            value: "4",
          },
        ],
      },
    },
  ];
};

const columns = ({ pdpa_type, handleClickDetail }) => {
  let tempMenu = [
    {
      Header: <div style={{ textAlign: "left" }}>Create Date</div>,
      accessor: "created_at",
      Cell: (props) => (
        <div onClick={() => handleClickDetail(props.row.original)}>
          {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Accepted date</div>,
      accessor: "accepted_at",
      Cell: (props) => (
        <div onClick={() => handleClickDetail(props.row.original)}>
          {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Name</div>,
      accessor: "first_name",
      Cell: (props) => (
        <div onClick={() => handleClickDetail(props.row.original)}>
          {props.value + " " + props.row.original.last_name}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Tel</div>,
      accessor: "phone_number",
      Cell: (props) => (
        <div onClick={() => handleClickDetail(props.row.original)}>
          {props.value}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Email</div>,
      accessor: "email",
      Cell: (props) => (
        <div onClick={() => handleClickDetail(props.row.original)}>
          {props.value}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>PDPA Code</div>,
      accessor: "pdpa_code",
      Cell: (props) => (
        <div onClick={() => handleClickDetail(props.row.original)}>
          {props.value}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Privacy</div>,
      accessor: "is_accepted_privacy_pdpa",
      Cell: (props) => (
        <div onClick={() => handleClickDetail(props.row.original)}>
          {props.value ? "YES" : "NO"}
        </div>
      ),
    },
  ];
  if (pdpa_type === "1") {
    tempMenu = [
      ...tempMenu,
      {
        Header: <div style={{ textAlign: "left" }}>Warranty</div>,
        accessor: "is_accepted_product_warranty_pdpa",
        Cell: (props) => (
          <div onClick={() => handleClickDetail(props.row.original)}>
            {props.value ? "YES" : "NO"}
          </div>
        ),
      },
      {
        Header: <div style={{ textAlign: "left" }}>Certified true info</div>,
        accessor: "is_accepted_certified_true_info_pdpa",
        Cell: (props) => (
          <div onClick={() => handleClickDetail(props.row.original)}>
            {props.value ? "YES" : "NO"}
          </div>
        ),
      },
      {
        Header: <div style={{ textAlign: "left" }}>Marketing</div>,
        accessor: "is_accepted_marketing_pdpa",
        Cell: (props) => (
          <div onClick={() => handleClickDetail(props.row.original)}>
            {props.value ? "YES" : "NO"}
          </div>
        ),
      },
    ];
  }
  return tempMenu;
};

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PDPAParticipationDetailContainer));
